import { Component } from "@theme/component";
import { ThemeEvents, CartUpdateEvent } from "@theme/events";

/**
 * Custom code: get the look
 *
 */
class ProductCardAdded extends Component {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(ThemeEvents.cartUpdate, this.onCartUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.cartUpdate, this.onCartUpdate);
  }

  /**
   * @param {CartUpdateEvent} event - The cart update event.
   */
  onCartUpdate = async (event) => {
    const productId = this.getAttribute("data-product-id");
    const updatedProductId = event.detail?.data?.productId;
    if (updatedProductId === productId) {
      this.setAttribute("data-is-added", "true");
      return;
    }

    const cartItems = event.detail?.resource?.items;
    if (!cartItems) {
      return;
    }

    const hasThisProduct = cartItems?.some(
      (item) =>
        String(item.product_id) === this.getAttribute("data-product-id"),
    );
    if (hasThisProduct) {
      this.setAttribute("data-is-added", "true");
      return;
    }

    this.removeAttribute("data-is-added");
  };
}

if (!customElements.get("product-card-added")) {
  customElements.define("product-card-added", ProductCardAdded);
}
